<section class="space-y-3">
  <header class="module-page-header">
    <div class="module-page-header__content">
      <h1 class="text-xl font-semibold mb-1 text-gray-900 dark:text-white">Dashboard</h1>
      <p class="text-sm text-gray-500 dark:text-gray-300">Ventas de hoy y alertas clave de inventario.</p>
    </div>
  </header>

  @if (dashboardState().loading) {
      <div class="grid w-full grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
        @for (item of [1, 2, 3]; track item) {
          <section class="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm dark:border-white/5 dark:bg-slate-900">
            <div class="h-5 w-28 animate-pulse rounded bg-slate-200 dark:bg-white/10"></div>
            <div class="mt-4 space-y-3">
              @for (line of [1, 2, 3]; track line) {
                <div class="h-12 animate-pulse rounded-xl bg-slate-100 dark:bg-white/5"></div>
              }
            </div>
          </section>
        }
      </div>
    } @else if (dashboardState().error) {
      <section class="rounded-2xl border border-red-200 bg-white p-5 text-sm text-red-700 shadow-sm dark:border-red-500/20 dark:bg-slate-900 dark:text-red-300">
        {{ dashboardState().error }}
      </section>
    } @else {
      <div class="grid w-full grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
        <section class="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm dark:border-white/5 dark:bg-slate-900">
          <div class="flex items-center justify-between">
            <h2 class="text-base font-semibold text-slate-900 dark:text-white">Pagos</h2>
            <span class="text-sm font-medium text-slate-500 dark:text-slate-400">Hoy</span>
          </div>

          <div class="mt-4 space-y-3">
            @if (payments().length) {
              @for (payment of payments(); track payment.paymentMethod) {
                <div class="rounded-xl border border-slate-200 bg-slate-50 px-4 py-3 dark:border-white/5 dark:bg-slate-950/70">
                  <div class="flex items-center justify-between gap-3">
                    <span class="text-sm text-slate-600 dark:text-slate-300">{{ payment.label }}</span>
                    <span class="text-lg font-semibold text-slate-900 dark:text-white">{{ payment.total | currency:'MXN':'symbol':'1.2-2' }}</span>
                  </div>
                </div>
              }
            } @else {
              <div class="rounded-xl border border-dashed border-slate-200 bg-slate-50 px-4 py-6 text-center dark:border-white/10 dark:bg-slate-950/50">
                <p class="text-sm text-slate-500 dark:text-slate-400">Sin pagos registrados hoy.</p>
              </div>
            }
          </div>
        </section>

        <section class="today-sales rounded-2xl border border-slate-200 bg-white p-5 shadow-sm dark:border-white/5 dark:bg-slate-900">
          @let salesTrend = thermometer();
          <div class="today-sales__header">
            <div>
              <h2 class="text-base font-semibold text-slate-900 dark:text-white">Ventas de hoy</h2>
              <p class="mt-1 text-sm text-slate-500 dark:text-slate-400">Resumen de tus ventas del día</p>
            </div>
            <span class="today-sales__icon bg-slate-100 text-slate-600 dark:bg-slate-950 dark:text-slate-300">
              <i class="fa-solid fa-bag-shopping" aria-hidden="true"></i>
            </span>
          </div>

          <div class="today-sales__total">
            <p class="text-sm text-slate-500 dark:text-slate-400">Total vendido</p>
            <p class="mt-1 text-3xl font-semibold text-slate-900 dark:text-white">
              {{ salesTrend.todayTotal | currency:'MXN':'symbol':'1.2-2' }}
            </p>
          </div>

          <div class="today-sales__comparison border-slate-200 dark:border-white/10">
            <i class="fa-solid fa-circle-info text-slate-500 dark:text-slate-400" aria-hidden="true"></i>
            <div>
              <p class="text-sm font-medium text-slate-900 dark:text-white">{{ salesTrend.comparisonTitle }}</p>
              <p class="mt-1 text-sm text-slate-500 dark:text-slate-400">
                @if (salesTrend.hasReference) {
                  Tu promedio diario es de {{ salesTrend.referenceAverage | currency:'MXN':'symbol':'1.2-2' }}.
                } @else {
                  Estamos reuniendo el historial necesario para mostrarte cómo van tus ventas frente a tu promedio diario.
                }
              </p>
            </div>
          </div>
        </section>

        @if (canViewStockAlerts()) {
        <section class="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm dark:border-white/5 dark:bg-slate-900">
          <div class="flex items-center justify-between">
            <h2 class="text-base font-semibold text-slate-900 dark:text-white">Alertas de stock</h2>
            <span class="text-sm font-medium text-slate-500 dark:text-slate-400">Inventario</span>
          </div>

          <div class="mt-4 space-y-4">
            <div class="space-y-2">
              <p class="text-sm font-medium text-slate-500 dark:text-slate-400">Stock bajo</p>
              @if (stockLists().lowStock.length) {
                <div class="space-y-2">
                  @for (item of stockLists().lowStock; track item.productBusinessId) {
                    <div class="rounded-xl border border-slate-200 bg-slate-50 px-3 py-3 dark:border-white/5 dark:bg-slate-950/70">
                      <div class="flex items-start justify-between gap-3">
                        <div>
                          <p class="text-sm font-medium text-slate-900 dark:text-slate-100">{{ item.productName }}</p>
                          <p class="text-xs text-slate-500 dark:text-slate-500">
                            Actual {{ item.availableStock | number:'1.0-0' }} · Mínimo {{ item.threshold | number:'1.0-0' }}
                          </p>
                        </div>
                        <span class="rounded-full bg-orange-500/15 px-2.5 py-1 text-xs font-medium text-orange-700 dark:text-orange-300">
                          Bajo
                        </span>
                      </div>
                    </div>
                  }
                </div>
              } @else {
                <div class="stock-empty">
                  <i class="fa-solid fa-circle-check" aria-hidden="true"></i>
                  <span>Sin alertas</span>
                </div>
              }
            </div>

            <div class="space-y-2">
              <p class="text-sm font-medium text-slate-500 dark:text-slate-400">Exceso de stock</p>
              @if (stockLists().overstock.length) {
                <div class="space-y-2">
                  @for (item of stockLists().overstock; track item.productBusinessId) {
                    <div class="rounded-xl border border-slate-200 bg-slate-50 px-3 py-3 dark:border-white/5 dark:bg-slate-950/70">
                      <div class="flex items-start justify-between gap-3">
                        <div>
                          <p class="text-sm font-medium text-slate-900 dark:text-slate-100">{{ item.productName }}</p>
                          <p class="text-xs text-slate-500 dark:text-slate-500">
                            Actual {{ item.availableStock | number:'1.0-0' }} · Máximo {{ item.threshold | number:'1.0-0' }}
                          </p>
                        </div>
                        <span class="rounded-full bg-cyan-500/15 px-2.5 py-1 text-xs font-medium text-cyan-700 dark:text-cyan-300">
                          Alto
                        </span>
                      </div>
                    </div>
                  }
                </div>
              } @else {
                <div class="stock-empty">
                  <i class="fa-solid fa-circle-check" aria-hidden="true"></i>
                  <span>Sin alertas</span>
                </div>
              }
            </div>
          </div>
        </section>
        }

        <section class="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm dark:border-white/5 dark:bg-slate-900">
          <div class="flex items-center justify-between">
            <h2 class="text-base font-semibold text-slate-900 dark:text-white">Más vendidos</h2>
            <span class="text-sm font-medium text-slate-500 dark:text-slate-400">Semana</span>
          </div>

          <div class="mt-4 space-y-2">
            @if (topProducts().bestSellers.length) {
              <div class="space-y-2">
                @for (item of topProducts().bestSellers; track item.productBusinessId) {
                  <div class="rounded-xl border border-slate-200 bg-slate-50 px-3 py-3 dark:border-white/5 dark:bg-slate-950/70">
                    <div class="flex items-start justify-between gap-3">
                      <div>
                        <p class="text-sm font-medium text-slate-900 dark:text-slate-100">{{ item.productName }}</p>
                        <p class="text-xs text-slate-500 dark:text-slate-500">
                          {{ item.quantitySold | number:'1.0-0' }} uds · {{ item.salesAmount | currency:'MXN':'symbol':'1.2-2' }}
                        </p>
                      </div>
                      <span class="rounded-full bg-cyan-500/15 px-2.5 py-1 text-xs font-medium text-cyan-700 dark:text-cyan-300">
                        Top
                      </span>
                    </div>
                  </div>
                }
              </div>
            } @else {
              <p class="text-sm text-slate-500 dark:text-slate-500">Aún no hay ventas registradas.</p>
            }
          </div>
        </section>

        <section class="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm dark:border-white/5 dark:bg-slate-900">
          <div class="flex items-center justify-between">
            <h2 class="text-base font-semibold text-slate-900 dark:text-white">Menos vendidos</h2>
            <span class="text-sm font-medium text-slate-500 dark:text-slate-400">Semana</span>
          </div>

          <div class="mt-4 space-y-2">
            @if (topProducts().leastSellers.length) {
              <div class="space-y-2">
                @for (item of topProducts().leastSellers; track item.productBusinessId) {
                  <div class="rounded-xl border border-slate-200 bg-slate-50 px-3 py-3 dark:border-white/5 dark:bg-slate-950/70">
                    <div class="flex items-start justify-between gap-3">
                      <div>
                        <p class="text-sm font-medium text-slate-900 dark:text-slate-100">{{ item.productName }}</p>
                        <p class="text-xs text-slate-500 dark:text-slate-500">
                          {{ item.quantitySold | number:'1.0-0' }} uds · {{ item.salesAmount | currency:'MXN':'symbol':'1.2-2' }}
                        </p>
                      </div>
                      <span class="rounded-full bg-orange-500/15 px-2.5 py-1 text-xs font-medium text-orange-700 dark:text-orange-300">
                        Bajo
                      </span>
                    </div>
                  </div>
                }
              </div>
            } @else {
              <p class="text-sm text-slate-500 dark:text-slate-500">No hay productos con baja venta para mostrar.</p>
            }
          </div>
        </section>
      </div>
    }
</section>
